<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title class="btn btn-rose">Add New City</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
            <form [formGroup]="addCityForm" (ngSubmit)="addCityForm.valid && saveCity()" novalidate>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field *ngIf="states.length > 0">
                            <mat-label>State</mat-label>
                            <mat-select [placeholder]="'States'"
                                formControlName="stateId">
                                <mat-form-field>
                                    <input matInput type="text" (keyup)="search($event.target.value)" placeholder="search state">
                                </mat-form-field>
                                <mat-divider></mat-divider>
                                <mat-option *ngFor="let state of selectedStates; let i = index;" [value]="state.stateId">
                                    {{state.stateName}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="addCityForm.get('stateId').hasError('required')">
                                State is required.
                              </mat-error>
                        </mat-form-field>
                      </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" color="accent">
                      <mat-label>City Name</mat-label>
                      <input matInput type="text" placeholder="Enter City Name" name="cityName" id="cityName"
                             formControlName="cityName" autocomplete="off" pattern=".*\S.*">
                      <mat-error *ngIf="addCityForm.get('cityName').hasError('required')">
                        City Name is required.
                      </mat-error>
                      <mat-error *ngIf="addCityForm.get('cityName').hasError('maxlength')">
                        City Name cannot be more than 50 characters.
                      </mat-error>
                    </mat-form-field>
                  </div>
                
                </div>
              </form>
        </mat-card-content>
        <mat-card-footer>
            <div class="row action-btn justify-content-center">
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="close()">Close</button>
                </div>
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="saveCity()" [disabled]="!addCityForm.valid">Save</button>
                </div>
            </div>
        </mat-card-footer>
    </mat-card>
</div>
